export default [
  {
    path: '/main/maintancereasons',
    meta: {
      tag: 'list_maintancereason',
      name: 'Motivos de manutenção',
      breadcrumb: 'Motivos de manutenção'
    },
    component: () => import(/* webpackChunkName: "maintancereasons-list" */ '@/views/main/settings/test-registers/maintancereason/Index.vue'),
    children: [
      {
        path: '',
        name: 'listmaintancereasons',
        meta: {
          tag: 'list_maintancereason',
          menu: 'settings',
          name: 'Motivos de manutenção'
        },
        component: () => import(/* webpackChunkName: "maintancereasons-list" */ '@/views/main/settings/test-registers/maintancereason/List.vue')
      },
      {
        path: '/main/maintancereason/add',
        name: 'addmaintancereason',
        meta: {
          tag: 'add_maintancereason',
          menu: 'settings',
          name: 'Adicionar | Motivo de Manutenção',
          breadcrumb: 'Adicionar Motivo de Manutenção'
        },
        component: () => import(/* webpackChunkName: "maintancereason-add" */ '@/views/main/settings/test-registers/maintancereason/Add.vue')
      },
      {
        path: '/main/maintancereason/:id',
        name: 'editmaintancereason',
        meta: {
          tag: 'edit_maintancereason',
          menu: 'settings',
          name: 'Editar | Motivo de Manutenção',
          breadcrumb: 'Editar Motivo de Manutenção'
        },
        component: () => import(/* webpackChunkName: "maintancereason-edit" */ '@/views/main/settings/test-registers/maintancereason/Edit.vue')
      }
    ]
  },
]
